import { useState } from 'react'

const STORAGE_KEY = 'ambcar-trade-acceptance-config'

export interface TradeAcceptanceConfig {
  maxMileage: number | null       // max km accepted, null = no limit
  maxAge: number | null           // max vehicle age in years, null = no limit
  minCondition: string            // '' = all accepted, 'new', 'excellent', 'good', 'regular', 'poor'
  acceptAlienated: boolean        // accept alienated/financed vehicles
  maxAlienatedDebtRatio: number   // max debt as % of offered value (0-100)
  autoApplyDepreciation: boolean  // auto-apply depreciation rules in evaluation panel
  requireFipe: boolean            // require FIPE value to allow saving
}

const DEFAULT_CONFIG: TradeAcceptanceConfig = {
  maxMileage: null,
  maxAge: null,
  minCondition: '',
  acceptAlienated: true,
  maxAlienatedDebtRatio: 100,
  autoApplyDepreciation: true,
  requireFipe: false,
}

export function useTradeAcceptanceConfig() {
  const [config, setConfig] = useState<TradeAcceptanceConfig>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY)
      return saved ? { ...DEFAULT_CONFIG, ...JSON.parse(saved) } : DEFAULT_CONFIG
    } catch {
      return DEFAULT_CONFIG
    }
  })

  const [isSaved, setIsSaved] = useState(false)

  const saveConfig = (updates: Partial<TradeAcceptanceConfig>) => {
    const next = { ...config, ...updates }
    setConfig(next)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    setIsSaved(true)
    setTimeout(() => setIsSaved(false), 2000)
  }

  const resetConfig = () => {
    setConfig(DEFAULT_CONFIG)
    localStorage.removeItem(STORAGE_KEY)
  }

  return { config, saveConfig, resetConfig, isSaved }
}
